import { useEffect, useRef } from 'react';

type PageKeyboardHandlers = {
    onKeyDown?: (event: KeyboardEvent) => void;
    onKeyUp?: (event: KeyboardEvent) => void;
    onPageBlur?: () => void;
};

export function usePageKeyboard(handlers: PageKeyboardHandlers) {
    let latestHandlers = useRef(handlers);
    latestHandlers.current = handlers;

    // eslint-disable-next-line no-restricted-syntax -- listening to the keyboard on the whole page is a window event subscription, which needs an effect with cleanup
    useEffect(() => {
        function handleKeyDown(event: KeyboardEvent) {
            if (latestHandlers.current.onKeyDown) {
                latestHandlers.current.onKeyDown(event);
            }
        }

        function handleKeyUp(event: KeyboardEvent) {
            if (latestHandlers.current.onKeyUp) {
                latestHandlers.current.onKeyUp(event);
            }
        }

        function handleBlur() {
            if (latestHandlers.current.onPageBlur) {
                latestHandlers.current.onPageBlur();
            }
        }

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        window.addEventListener('blur', handleBlur);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
            window.removeEventListener('blur', handleBlur);
        };
    }, []);
}
